import React, { useEffect, useState } from 'react'
import { Link } from 'react-scroll';
import { Breakpoint } from 'react-socks';
import '../styles/Header.scss';
import Sidebar from './Sidebar';

function Header() {
  const [show, handleShow] = useState(false);

  useEffect(() => {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 750) {
        handleShow(true);
      } else {
        handleShow(false);
      }
    });

    return () => {
      window.removeEventListener('scroll');
    };
  }, []);

  return (
    <div>
      <Breakpoint medium up>
        {show ?
         <div className='header'>
         <div className='header-left'>
             <div className='header-options'>
             <Link
                activeClass='active'
                to='home'
                spy={true}
                smooth={true}
                offset={-10}
                duration={500}
              >
              home
              </Link>
             </div>
         </div>

         <div className='header-right'>
             <div className='header-options'>
             <Link
                activeClass='active'
                to='about'
                spy={true}
                smooth={true}
                offset={-10}
                duration={500}
              >
              about
              </Link>
             </div>

             <div className='header-options'>
             <Link
                activeClass='active'
                to='work'
                spy={true}
                smooth={true}
                offset={-10}
                duration={500}
              >
              work
              </Link>
             </div>
         
             <div className='header-options'>
             <Link
                activeClass='active'
                to='contact'
                spy={true}
                smooth={true}
                offset={-10}
                duration={500}
              >
              contact
              </Link>
             </div>
         </div>
       </div>
       :
       <div></div>
       }
       
      </Breakpoint>
      
      <Breakpoint small down>
        <Sidebar />
      </Breakpoint>
    </div>
  )
}

export default Header
